import { render, staticRenderFns } from "./TransactionsListAddNew.vue?vue&type=template&id=321b6db0"
import script from "./TransactionsListAddNew.vue?vue&type=script&lang=js"
export * from "./TransactionsListAddNew.vue?vue&type=script&lang=js"
import style0 from "./TransactionsListAddNew.vue?vue&type=style&index=0&id=321b6db0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports